import {defineStore} from "pinia";
export const useCodificationStore = defineStore('codification', {
    state: () => ({
        codification: {},
        codifications: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setCodification(codification) {
            this.codification = codification
        },
        setCodifications(codifications) {
            this.codifications = codifications
        },
        addCodification(codification) {
            this.codifications.unshift(codification)
        },
        updateCodification(codification) {
            let index = this.codifications.findIndex(cl => cl.id === codification.id)
            this.codifications.splice(index, 1, codification)
        },
        deleteCodification(codification) {
            let index = this.codifications.findIndex(cl => cl.id === codification.id)
            this.codifications.splice(index, 1)
        },
    },
});